import React, { useState } from "react";
import AddNewsComp from "../components/AddNewsComp";
import { addnews } from "../services/newsService";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";

const AddNews = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleAddNews = async (formData) => {
    setLoading(true);
    setMessage("");

    try {
      const result = await addnews(formData); // ✅ Use your Axios-based addnews function
      if (result.success) {
        setMessage(result.message);
      } else {
        setMessage(result.message);
      }
    } catch (error) {
      setMessage(error || "Error connecting to the server.");
    }

    setLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>AddNews - Factbazaar</title>
        <meta name="description" content="Submit the latest news articles on Factbazaar and keep the world informed with reliable and accurate information." />
  <meta name="keywords" content="Add News, Submit News, Factbazaar, News Portal, Breaking News, Journalism" />
  <meta name="author" content="Factbazaar Team" />
      </Helmet>
      <Layout>
      <AddNewsComp onSubmit={handleAddNews} loading={loading} />
      {message && <p className="message">{message}</p>}
      </Layout>
    </div>
  );
};

export default AddNews;